var render = function render(){var _vm=this,_c=_vm._self._c;return ((this.$store.state.status != 'Empty') && (this.$store.state.status != 'Original'))?_c('div',{staticClass:"progress-bar"},[_c('span',{staticClass:"status"},[_vm._v(_vm._s(this.$store.state.status))]),_c('v-progress-linear',{attrs:{"value":this.$store.state.progress,"color":"#50fa7b","height":"5","dark":"","rounded":""}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }